import gql from 'graphql-tag';

const userSearchQuery = gql`
  query ($searchParam: String) {
    searchUser(searchParam: $searchParam) {
      id
      username
      email
      active
      roles
      locationInitials
      authenticationToken
      legacySiteDisabled
    }
  }
`;

export default userSearchQuery;
